import axios from 'axios';
import { getApiUrl } from '../config/api.config';

// NOTE: Do NOT call getApiUrl() at module load time!
// It must be called at request time when window.location is available.
const PORTAL_LOGIN_URL = 'https://visual.eigentrage.com/login';

// Configure axios defaults
axios.defaults.withCredentials = true;

// Get username from URL or localStorage
export const getUsername = () => {
  try {
    // Check URL parameter first
    const urlParams = new URLSearchParams(window.location.search);
    const urlUser = urlParams.get('user');

    if (urlUser && urlUser !== 'Guest') {
      try { localStorage.setItem('username', urlUser); } catch (e) { /* ignore */ }
      return urlUser;
    }

    // Fallback to localStorage
    return localStorage.getItem('username');
  } catch (e) {
    return null;
  }
};

// Add request interceptor to append user parameter to all API calls
axios.interceptors.request.use((config) => {
  const username = getUsername();
  if (username && config.url) {
    try {
      // Handle both absolute and relative URLs
      const isAbsolute = config.url.startsWith('http');
      const baseUrl = isAbsolute ? '' : window.location.origin;
      const url = new URL(config.url, baseUrl || undefined);
      if (!url.searchParams.has('user')) {
        url.searchParams.set('user', username);
        config.url = isAbsolute ? url.toString() : url.pathname + url.search;
      }
    } catch (e) {
      // If URL parsing fails, just continue without modification
    }
  }
  return config;
});

// Add response interceptor to handle 401s
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const redirect = error.response.data?.redirect || PORTAL_LOGIN_URL;
      try { localStorage.removeItem('username'); } catch (e) { /* ignore */ }
      window.location.href = redirect;
    }
    return Promise.reject(error);
  }
);

export const login = async (username, password) => {
  return axios.post(`${getApiUrl()}/auth/login`, { username, password });
};

export const logout = async () => {
  try { localStorage.removeItem('username'); } catch (e) { /* ignore */ }
  return axios.post(`${getApiUrl()}/auth/logout`);
};

export const checkAuth = async () => {
  const username = getUsername();
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  let url = `${getApiUrl()}/auth/check`;
  const params = new URLSearchParams();
  if (username) params.set('user', username);
  if (token) params.set('token', token);
  if (params.toString()) url += `?${params.toString()}`;

  return axios.get(url);
};

export const checkAuthStatus = async () => {
  try {
    const response = await checkAuth();
    if (response.data.authenticated) {
      try { localStorage.setItem('username', response.data.username); } catch (e) { /* ignore */ }
      try {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('token')) {
          urlParams.delete('token');
          const cleanUrl = urlParams.toString()
            ? `${window.location.pathname}?${urlParams.toString()}`
            : window.location.pathname;
          window.history.replaceState({}, '', cleanUrl);
        }
      } catch (e) { /* ignore */ }
      return true;
    }
    return false;
  } catch (error) {
    console.error('[Auth] Error during auth check:', error?.message);
    return false;
  }
};